import React, {useContext} from "react";
import {Button, Icon, IconButton, makeStyles, Tooltip} from "@material-ui/core";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import useConfirm from "../../../../../../JsonScreen/Utils/Confirmation/useConfirm";

const useStyles = makeStyles({
    actionsWrapper: {
        display: 'flex',
        width: '100%',
        borderTop: '1px solid #d8d8d8',
        position: 'absolute',
        alignItems: 'center',
        bottom: 0,
        height: 50
    },
    button: {
        marginLeft: 7,
        alignSelf: 'baseline'
    },
    buttonGroup: {
        width: '100%',
        display: 'flex',
        alignItems: 'center'
    },
    defaultButtonsContainer: {
        width: '70%'
    },
    preSaveContainer: {
        width: '30%',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    setupButton: {
        margin: '0 7px 0 auto',
        padding: 0
    }
});

const ToolBarActions = () => {
    const classes = useStyles();
    const {saveScreen, removeScreen, closeScreen, loading, toggleOpenTemplates} = useContext(ScreenDesignerContextNew);
    const {confirm} = useConfirm();
    return (
        <div className={classes.actionsWrapper}>
            <div className={classes.buttonGroup}>
                <div className={classes.defaultButtonsContainer}>
                    <Button className={classes.button}
                            disabled={loading}
                            variant={"contained"}
                            color={"primary"}
                            size={"small"}
                            onClick={() => saveScreen()}>
                        Save
                    </Button>
                    <Button
                        disabled={loading}
                        className={classes.button}
                        variant={"contained"}
                        size={"small"}
                        onClick={() => {
                            confirm({
                                submitFn: removeScreen
                            })
                        }}
                    >
                        Delete
                    </Button>
                    <Button
                        disabled={loading}
                        className={classes.button}
                        variant={"contained"}
                        size={"small"}
                        onClick={closeScreen}
                    >
                        Cancel
                    </Button>
                </div>
                <div className={classes.preSaveContainer}>
                    <Tooltip title={'Select template'}>
                        <IconButton onClick={toggleOpenTemplates}>
                            <Icon>
                                backup
                            </Icon>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={'Save without exit'}>
                        <IconButton onClick={() => saveScreen(true)}>
                            <Icon>
                                save
                            </Icon>
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
        </div>
    )
};
export default ToolBarActions